import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { observer, useLocalObservable } from "mobx-react"
import { Flex, Form, Tabs, type TabsProps, Typography } from "antd"

import css from "@src/pages/settings/index.module.css"
import { SettingsDomainPage } from "@src/pages/settingsDomain"
import { SettingsWhitelistPage } from "@src/pages/settingsWhitelist"
import { SettingsWhiteListIpPage } from "@src/pages/settingsWhiteListIp"
enum SettingTab {
  DomainPage = "dp",
  WhiteListAddresses = "wlad",
  WhiteListIp = "wlip",
}
export const SettingsAllowlistPage = observer(() => {
  const SettingsTabQuery = "inner-tab"
  const [searchParams, setSearchParams] = useSearchParams()
  const currentTab = searchParams.get(SettingsTabQuery) as SettingTab

  const updateQuery = (key: string) => {
    const newParams = new URLSearchParams(searchParams.toString())

    newParams.set(SettingsTabQuery, key)

    setSearchParams(newParams)
  }

  const items: TabsProps["items"] = [
    {
      children: <SettingsDomainPage />,
      key: SettingTab.DomainPage,
      label: `Checkout Domains`,
    },
    {
      children: <SettingsWhitelistPage />,
      key: SettingTab.WhiteListAddresses,
      label: `Withdrawal Addresses`,
    },
    {
      children: <SettingsWhiteListIpPage />,
      key: SettingTab.WhiteListIp,
      label: `API key IPs`,
    },
  ]

  useEffect(() => {
    if (!currentTab) {
      updateQuery(SettingTab.DomainPage)
    }
  }, [currentTab])

  return (
    <Flex gap={32} vertical>
      <Tabs
        activeKey={currentTab}
        className={css.tabs}
        items={items}
        onChange={(key) => updateQuery(key)}
      />
    </Flex>
  )
})
